export type LegacyStyleObject = {
  backgroundColor?: string;
  borderColor?: string;
  borderRadius?: string;
  borderWidth?: string;
  borderStyle?: string;
  color?: string;
  gap?: string;
  padding?: string;
  paddingY?: string;
  paddingX?: string;
  margin?: string;
  marginY?: string;
  marginX?: string;
  marginBottom?: string;
  marginTop?: string;
  fontSize?: string;
  fontWeight?: string;
  alignItems?: string;
  height?: string;
  width?: string;
};

export type LCColorValue<T = string> = T | { custom?: string };

export type BorderStrokeValue = {
  width?: string;
  style?: string;
  color?: LCColorValue;
};

export type BorderStrokeDirectionValue = Partial<Record<string, BorderStrokeValue>>;

export type BorderStrokeStyleValue = {
  all?: BorderStrokeValue;
  custom?: BorderStrokeDirectionValue;
};

export type StyleObject = {
  gap?:
    | string // can be when hideDirection is true
    | {
        x?: string;
        y?: string;
        all?: string;
        custom?: string;
      };
  // TODO: Remove this
  gapSecondary?: {
    x?: string;
    y?: string;
    all?: string;
    custom?: string;
  };
  padding?: {
    x?: string;
    y?: string;
    t?: string;
    b?: string;
    l?: string;
    r?: string;
    all?: string;
    custom?: {
      t?: string;
      b?: string;
      l?: string;
      r?: string;
    };
  };
  margin?: {
    x?: string;
    y?: string;
    t?: string;
    b?: string;
    l?: string;
    r?: string;
    all?: string;
    custom?: {
      t?: string;
      b?: string;
      l?: string;
      r?: string;
    };
  };
  color?: LCColorValue;
  flexWrap?: string;
  hoverColor?: string;
  activeColor?: string;
  backgroundColor?: LCColorValue;
  backgroundImage?: string | { custom?: string };
  backgroundSize?: string;
  backgroundRepeat?: string;
  borderColor?:
    | LCColorValue
    | {
        all?: LCColorValue;
        custom?: {
          t?: LCColorValue;
          r?: LCColorValue;
          b?: LCColorValue;
          l?: LCColorValue;
        };
      };
  overflow?: {
    all?: string;
    x?: string;
    y?: string;
  };
  borderRadius?:
    | string // can be when hideDirection is true
    | {
        tl?: string;
        tr?: string;
        bl?: string;
        br?: string;
        all?: string;
        custom?: {
          tl?: string;
          tr?: string;
          bl?: string;
          br?: string;
        };
      };
  borderWidth?:
    | string // can be when hideDirection is true
    | {
        x?: string;
        y?: string;
        t?: string;
        b?: string;
        l?: string;
        r?: string;
        all?: string;
        custom?: {
          t?: string;
          b?: string;
          l?: string;
          r?: string;
        };
      };
  borderStyle?:
    | string
    | {
        all?: string;
        custom?: {
          t?: string;
          r?: string;
          b?: string;
          l?: string;
        };
      };
  borderStroke?: BorderStrokeStyleValue;
  boxShadow?: { all: string } | string;
  fontSize?: string;
  fontWeight?: string;
  minHeight?: string | { custom?: string };
  maxHeight?: string | { custom?: string };
  minWidth?: string | { custom?: string };
  maxWidth?: string | { custom?: string };
  width?: string | { custom?: string };
  breakAfter?: string;
  height?: string | { custom?: string };
  layout?: string;
  textDecoration?: string;
  fontFamily?: string;
  fontStyle?: string;
  textTransform?: string;
  lineHeight?: string | { custom?: string };
  letterSpacing?: string | { custom?: string };
  chartHoverColor?: LCColorValue;
  chartActiveColor?: LCColorValue;
  visibility?: string;
  position?: string;
  opacity?: string;
  rotation?: {
    custom: string;
  };
  legendsPadding?: {
    x?: string;
    y?: string;
    t?: string;
    b?: string;
    l?: string;
    r?: string;
    all?: string;
    custom?: {
      t?: string;
      b?: string;
      l?: string;
      r?: string;
    };
  };
  tableCellPadding?: {
    x?: string;
    y?: string;
    t?: string;
    b?: string;
    l?: string;
    r?: string;
    all?: string;
    custom?: {
      t?: string;
      b?: string;
      l?: string;
      r?: string;
    };
  };
};

export enum BlockThemeEnum {
  LIGHT = 'light',
  DARK = 'dark',
  INHERIT = 'inherit',
}
